import React from 'react'
import Navbar from '../Navbar';
import Footer from '../Footer';
import investerBanner from '../../assests/investor relationship/handshake.webp';
import '../../hamcss/investor.css';
import { useState } from 'react'
import { FaRegFilePdf } from "react-icons/fa";
import { Link } from 'react-router-dom';
import fy26a from '../../assests/sgPdf/public_disclosures/fy25_26/Public Disclosure on Liquidity Risk – September 2025.pdf';
import fy26b from '../../assests/sgPdf/public_disclosures/fy25_26/Public Disclosure on Liquidity Risk – June 2025.pdf';
import fy26c from '../../assests/sgPdf/public_disclosures/fy25_26/Public Disclosure on Liquidity Risk - December 2025.pdf';
import fy26d from '../../assests/sgPdf/public_disclosures/fy25_26/Public Disclosure on Liquidity Risk - March 2026.pdf';
import fy27a from '../../assests/sgPdf/public_disclosures/fy26_27/Public Disclosure on Liquidity Risk - June 2026.pdf';
import fy27b from '../../assests/sgPdf/public_disclosures/fy26_27/Public Disclosure on Liquidity Risk - September 2026.pdf';

const PublicDisclosures = () => {

    const [selectedOption, setSelectedOption] = useState("option"); // State to track selected option

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value); // Update selected option when changed
    };


    return (
        <>

            <Navbar />
            <section>
                <div className="BreadArea" style={{
                    //  for /beta server 
                    backgroundImage: `url(${investerBanner})`,
                    // backgroundImage: "url('images/Bread.png')",
                }}>
                    <div className="container">
                        <h2>Public Disclosures </h2>
                    </div>
                </div>
            </section>


            <section className="main-an">

                <div className="main-an-box">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 className='h2-text'>Public Disclosures </h2>
                        <div>
                            <select className="select-class" onChange={handleOptionChange}>
                                <option value="option">FY 2026-2027</option>
                                <option value="option0">FY 2025-2026</option>


                            </select>
                        </div>
                    </div>

                    <div style={{ marginTop: '50px' }}>
                        {/* Conditionally render PDFs based on selected option */}
                        {selectedOption === "option" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27a} target='blank'>  <h6>Public Disclosure on Liquidity Risk - June 2026</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy27b} target='blank'>  <h6>Public Disclosure on Liquidity Risk - September 2026</h6> </a>
                                </div>
                                
                                
                        </>

                        )}
                        {selectedOption === "option0" && (
                            <>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26a} target='blank'>  <h6>Public Disclosure on Liquidity Risk – September 2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26b} target='blank'>  <h6>Public Disclosure on Liquidity Risk – June 2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26c} target='blank'>  <h6>Public Disclosure on Liquidity Risk - December 2025</h6> </a>
                                </div>
                                <div className="pdf-clas">
                                    <FaRegFilePdf size={25} style={{ color: 'red' }} />
                                    <a href={fy26d} target='blank'>  <h6>Public Disclosure on Liquidity Risk - March 2026</h6> </a>
                                </div>
                                
                                
                        </>

                        )}
                        
                        
                    </div>
                </div>

            </section>



            <Footer />


        </>
    )
}




export default PublicDisclosures